import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import Store from "./store/Store";
import { Provider } from "react-redux";
import "antd/dist/antd.css";
ReactDOM.render(
  <React.StrictMode>
    <Provider store={Store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
